import { render, staticRenderFns } from "./HotAlertLink.vue?vue&type=template&id=5b7a9fe0&"
import script from "./HotAlertLink.vue?vue&type=script&lang=js&"
export * from "./HotAlertLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports